{
  "SERVICES_LIST_PAGE": "Välj tjänst",
  "SERVICES_CONFIRMATION_PAGE": "Beställ",
  "SERVICES_THANK_YOU_PAGE": "Klart!"
}
